import styled from 'styled-components';
import Parent from './style';

const Wrapper = styled(Parent.Wrapper)`
  padding: 2%;
`;
const TopWrapper = styled(Parent.TopWrapper)``;
const TableWrapper = styled(Parent.TableWrapper)``;
const ModalWrapper = styled(Parent.ModalWrapper)``;
const Styled = { Wrapper, TopWrapper, TableWrapper, ModalWrapper };

export default Styled;
